import styled from 'styled-components';

export const LiveArenaWidgetAmountBox = styled.div`
    color: ${props => props.theme.components.partyJackpotInGameWidget.colors.amount};
    font-family: ${props => props.theme.font.family.ultra};
    font-size: 20px;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 14px;
    }
`;